import React, { useState } from 'react';
import {
  NamedLink,
  ReviewRating,
  IconButtonArrow,
  IconQuotes,
  AvatarLarge,
  Heading,
  ButtonTabNavHorizontal
} from '../../../components';
import { createSlug } from '../../../util/urlHelpers';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER, } from '../../../util/types';

import css from './SectionUserReviews.module.css';

const REVIEWS_LIMIT = 3;

const SectionUserReviews = props => {

  const {
    reviews,
    fetchReviewsError
  } = props;


  if (!reviews?.length) return null;

  const [showReviewsType, setShowReviewsType] = useState(REVIEW_TYPE_OF_PROVIDER);

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;

  const reviewTabs = [
    {
      text: (
        <Heading as="h3" rootClassName={css.reviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsFromMyCustomersTitle"
            values={{ count: reviewsOfProvider.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeProviderSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
    },
    {
      text: (
        <Heading as="h3" rootClassName={css.reviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsAsACustomerTitle"
            values={{ count: reviewsOfCustomer.length }}
          />
        </Heading>
      ),
      selected: isReviewTypeCustomerSelected,
      onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
    },
  ];

  const reviewsData = isReviewTypeProviderSelected ? reviewsOfProvider : reviewsOfCustomer;

  

  return (
    <div className={css.root}>
      <ButtonTabNavHorizontal className={css.reviewsTabNav} tabs={reviewTabs} />
      <div className={css.reviewsHolder}>
        {reviewsData.map((r, i) => {

          return (
            <div className={css.review} key={`review-${r?.rating}-${i}`}>

              <div className={css.reviewAuthor}>
                <AvatarLarge className={css.reviewAuthorImg} user={r?.author} disableProfileLink />

                <span className={css.reviewAuthorName}>
                  {r?.author?.attributes?.profile?.displayName}
                </span>

                <IconQuotes className={css.reviewQuotes} />
              </div>

              <ReviewRating
                rating={r?.attributes?.rating}
                className={css.reviewRating}
                reviewStarClassName={css.reviewRatingStar}
              />

              <p className={css.reviewText}>
                {r?.attributes?.content}
              </p>

              {r?.listingId && r?.listingTitle && (
                <NamedLink
                  name='ListingPage'
                  params={{
                    id: r.listingId,
                    slug: createSlug(r.listingTitle)
                  }}
                  className={css.reviewLink}
                >
                  VIEW WORKSHOP
                  <IconButtonArrow />
                </NamedLink>
              )}

            </div>
          )
        })}
      </div>

      {/* {reviewsData?.length > REVIEWS_LIMIT && reviewsItems?.length !== reviewsData?.length && (
        <div className={css.seeAll} onClick={() => setReviewsItems(reviewsData)}>
          <FormattedMessage id="ListingCard.seeAll" />
          <IconButtonArrow />
        </div>
      )} */}
    </div>
  );
};

export default SectionUserReviews;
